import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'indexToColor'
})
export class IndexToColorPipe implements PipeTransform {

  transform(index: number): string {
    const colorMap = ['#4FCC53', '#FCD03D', '#F9A91B', '#F78725', '#E73740'];

    return index != null ? colorMap[index] : null;
  }
}
